/**
 * Utility functions for calculating league dates from matches
 */

export interface Match {
  id: number;
  match_date: string;
  opponent_name: string;
  [key: string]: any;
}

/**
 * Calculate the first match date from an array of matches
 * @param matches Array of match objects
 * @returns Date string in YYYY-MM-DD format, or empty string if no matches
 */
export function calculateFirstMatchDate(matches: Match[]): string {
  if (!matches || matches.length === 0) {
    return '';
  }

  // Sort matches by date (ascending)
  const sortedMatches = [...matches].sort((a, b) => {
    const dateA = new Date(a.match_date).getTime();
    const dateB = new Date(b.match_date).getTime();
    return dateA - dateB;
  });

  const firstMatch = sortedMatches[0];
  const matchDate = new Date(firstMatch.match_date);
  
  // Return date in YYYY-MM-DD format
  return matchDate.toISOString().split('T')[0];
}

/**
 * Calculate the last match date from an array of matches
 * @param matches Array of match objects
 * @returns Date string in YYYY-MM-DD format, or empty string if no matches
 */
export function calculateLastMatchDate(matches: Match[]): string {
  if (!matches || matches.length === 0) {
    return '';
  }

  // Sort matches by date (descending)
  const sortedMatches = [...matches].sort((a, b) => {
    const dateA = new Date(a.match_date).getTime();
    const dateB = new Date(b.match_date).getTime();
    return dateB - dateA;
  });

  const lastMatch = sortedMatches[0];
  const matchDate = new Date(lastMatch.match_date);
  
  // Return date in YYYY-MM-DD format
  return matchDate.toISOString().split('T')[0];
}

